import React from 'react';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';

export const HealthPlanCoverage = (props) => {
  return (
    <React.Fragment>
      <RadioGroup
        label="Are you servicing members with AARP Supplemental Health Plan coverage?"
        model="attestation.healthProgram"
        aria-labelledby="radio-provider"
        validators={{ required: true }}
        defaultValue="no"
      >
        <RadioGroup.Radio id="radio-health-program-no" value="no" label="No" />
        <RadioGroup.Radio
          id="radio-health-program-aarp"
          value="aarp"
          label="Yes exclusively AARP members"
        />
        <RadioGroup.Radio
          id="radio-health-program-uhc"
          value="uhc"
          label="Yes along with other UHC members"
        />
      </RadioGroup>
    </React.Fragment>
  );
};

HealthPlanCoverage.propTypes = {};

HealthPlanCoverage.defaultProps = {};
